export default __webpack_public_path__ + "static/media/lp-sec03_ttl.2b220e7b.png";